import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { Options } from '@emotion/cache';

export const commonCache: Options = {
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin]
};
